import { Button, Col, Modal, Row, Spin, Tabs } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { toastText } from 'utils/utils';
import EmploymentDetails from './EmployentDetails';
import TaxationDetails from './TaxationDetails';
import styles from './index.module.scss';
import './index.scss';
import { HistoryOutlined } from '@ant-design/icons';
import { employeeApi } from 'Api/employee';
import { SideDrawerWrapper } from 'components/Global';
import { PermissionContext } from 'components/Global/AuthLayout';
import dayjs from 'dayjs';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CloseSvg, DeductionsIconSvg, EarningsIconSvg } from 'utils/svgs';
import { fetchConstantDropdownAction } from '../../redux/actions/constantDropdownAction';
import Documents from './Documents';
import EmployeeActivityBody from './EmployeeActivity';
import MasterDeductionTab from './MasterDeductionsTab';
import MasterEarningsTab from './MasterEarningsTab';
import OpeningBalance from './OpeningBalance';
import PaymentInfo from './PayementInfo';
import SalaryDetails from './SalaryDetails';

type Props = {
	onCancel: () => void;
	isAddEmployeeModalOpen: boolean;
	nhimaAgeLimit: number;
	napsaAgeLimit: number;
};

const AddEmployee = (props: Props) => {
	const navigate = useNavigate();
	const { onCancel, isAddEmployeeModalOpen, nhimaAgeLimit, napsaAgeLimit } =
		props;

	const allowedTabs = ['earnings', 'deductions'];

	const dispatch = useDispatch<AppDispatch>();
	const { isLoading } = useSelector((state: any) => state.constantDropdown);
	const [searchParams] = useSearchParams();
	const initialTab = searchParams.get('tab');

	const initialPeriod = searchParams.get('period');
	const [employeeDetails, setEmployeeDetails] = useState<any>();
	const [activeKey, setActiveKey] = useState<string>(() => {
		const tab = initialTab ?? '';
		return allowedTabs.includes(tab) ? tab : 'employmentDetails';
	});
	const [selectedPeriod] = useState(() => initialPeriod || '');

	const [employeeId, setEmployeeId] = useState<string>('');
	const [isEmployeeActivityOpen, setIsEmployeeActivityOpen] =
		useState<boolean>(false);
	const [earningsYear, setEarningsYear] = useState<any>(dayjs());
	const [earningsMonth, setEarningsMonth] = useState(
		new Date().getMonth() + 1
	);
	const [isEmployeeSalaryExists, setIsEmployeeSalaryExists] =
		useState<boolean>(false);
	const [isEmployeeTaxationExists, setIsEmployeeTaxationExists] =
		useState<boolean>(false);
	const [isPayrollRun, setIsPayrollRun] = useState(false);
	const [lastDateOfPayPeriod, setLastDateOfPayPeriod] = useState<
		string | null
	>(null);
	const permissions = useContext(PermissionContext).allowedPermissions;

	const changeTab = (key: any) => {
		setActiveKey(key);
	};

	const onEarningsYearChange = (selectedYear: any) => {
		setEarningsYear(selectedYear);
	};
	const onEarningsMonthChange = (month: number) => {
		setEarningsMonth(month);
	};

	const [isUsd, setIsUsd] = useState<boolean>(false);

	let modalTitle = searchParams.get('employeeId')
		? 'Edit Employee'
		: 'Add Employee';

	let items = [
		{
			key: 'employmentDetails',
			label: 'Employment',
			destroyInactiveTabPane: false,
			children: (
				<EmploymentDetails
					changeTab={changeTab}
					onCancel={onCancel}
					employeeId={employeeId}
					employeeData={employeeDetails}
					setEmployeeId={setEmployeeId}
					nhimaAgeLimit={nhimaAgeLimit}
					napsaAgeLimit={napsaAgeLimit}
					lastDateOfPayPeriod={lastDateOfPayPeriod}
					isPayrollRun={isPayrollRun}
					getEmployeeDetail={(employeeId: string) => {
						getEmployeeDetail(employeeId);
					}}
				/>
			),
		},
		{
			key: 'taxationDetails',
			label: 'Taxation',
			destroyInactiveTabPane: true,
			children: searchParams.get('employeeId') ? (
				<TaxationDetails
					changeTab={changeTab}
					onCancel={onCancel}
					setIsUsd={setIsUsd}
					setIsEmployeeTaxationExists={setIsEmployeeTaxationExists}
				/>
			) : (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '50vh',
						cursor: 'pointer',
						padding: '10px', // Adjust padding as needed
					}}
					onClick={() => {
						changeTab('employmentDetails');
					}}
				>
					Add{' '}
					<span
						style={{
							textDecoration: 'underline',
							marginLeft: '5px',
							marginRight: '5px',
						}}
						className="color-purple"
					>
						{' '}
						Employment{' '}
					</span>{' '}
					Details First!!
				</div>
			),
		},
		{
			key: 'salaryDetails',
			label: 'Salary',
			destroyInactiveTabPane: true,
			children:
				!searchParams.get('employeeId') || !isEmployeeTaxationExists ? (
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '50vh',
							cursor: 'pointer',
						}}
						onClick={() => {
							!isEmployeeTaxationExists
								? changeTab('taxationDetails')
								: changeTab('employmentDetails');
						}}
					>
						Add
						{''}
						<span
							style={{
								textDecoration: 'underline',
								marginLeft: '5px',
								marginRight: '5px',
							}}
							className="color-purple"
						>
							{!isEmployeeTaxationExists
								? 'Taxation'
								: 'Employment'}
						</span>
						{''}Details First!!
					</div>
				) : (
					<SalaryDetails
						employeeId={employeeId}
						setIsEmployeeSalaryExists={setIsEmployeeSalaryExists}
						isViewMode={false}
						isUsd={isUsd}
					/>
				),
		},
		{
			key: 'paymentInfo',
			label: 'Payment Info',
			destroyInactiveTabPane: false,
			children: searchParams.get('employeeId') ? (
				<PaymentInfo isUsd={isUsd} />
			) : (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '50vh',
						cursor: 'pointer',
					}}
					onClick={() => {
						changeTab('employmentDetails');
					}}
				>
					Add
					{''}
					<span
						style={{
							textDecoration: 'underline',
							marginLeft: '5px',
							marginRight: '5px',
						}}
						className="color-purple"
					>
						Employment
					</span>
					{''}Details First!!
				</div>
			),
		},
		{
			key: 'documents',
			label: 'Documents',
			destroyInactiveTabPane: true,
			children: searchParams.get('employeeId') ? (
				<Documents isViewMode={false} />
			) : (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '50vh',
						cursor: 'pointer',
					}}
					onClick={() => {
						changeTab('employmentDetails');
					}}
				>
					Add
					{''}
					<span
						style={{
							textDecoration: 'underline',
							marginLeft: '5px',
							marginRight: '5px',
						}}
						className="color-purple"
					>
						Employment
					</span>
					{''}Details First!!
				</div>
			),
		},

		{
			key: 'earnings',
			label: (
				<span
					style={{
						display: 'inline-flex',
						alignItems: 'center',
						verticalAlign: 'middle', // Align icon with text
					}}
				>
					<EarningsIconSvg /> <span>Earnings</span>
				</span>
			),

			destroyInactiveTabPane: true,
			children:
				isEmployeeSalaryExists && searchParams.get('employeeId') ? (
					<MasterEarningsTab
						onYearChange={onEarningsYearChange}
						onMonthChange={onEarningsMonthChange}
						activeTab={activeKey}
						year={earningsYear}
						month={earningsMonth}
						employeeId={searchParams.get('employeeId') as string}
						isUSD={isUsd}
						selectedPayPeriodFromURL={selectedPeriod}
						isViewMode={false}
					/>
				) : (
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '50vh',
							cursor: 'pointer',
						}}
						onClick={() => {
							changeTab(
								searchParams.get('employeeId')
									? 'salaryDetails'
									: 'employmentDetails'
							);
						}}
					>
						Add
						{''}
						<span
							style={{
								textDecoration: 'underline',
								marginLeft: '5px',
								marginRight: '5px',
							}}
							className="color-purple"
						>
							{!searchParams.get('employeeId')
								? ' Employment '
								: ' Salary '}

							{''}
						</span>
						{''}Details First!!
					</div>
				),
		},
		{
			key: 'deductions',
			destroyInactiveTabPane: true,
			label: (
				<span
					style={{
						display: 'inline-flex',
						alignItems: 'center',
						verticalAlign: 'middle', // Align icon with text
					}}
				>
					<DeductionsIconSvg /> <span>Deductions</span>
				</span>
			),
			children:
				isEmployeeSalaryExists && searchParams.get('employeeId') ? (
					<MasterDeductionTab
						activeTab={activeKey}
						employeeId={searchParams.get('employeeId') as string}
						isUSD={isUsd}
					/>
				) : (
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '50vh',
							cursor: 'pointer',
						}}
						onClick={() => {
							changeTab(
								searchParams.get('employeeId')
									? 'salaryDetails'
									: 'employmentDetails'
							);
						}}
					>
						Add
						{''}
						<span
							style={{
								textDecoration: 'underline',
								marginLeft: '5px',
								marginRight: '5px',
							}}
							className="color-purple"
						>
							{!searchParams.get('employeeId')
								? ' Employment '
								: ' Salary '}
						</span>
						{''}Details First!!
					</div>
				),
		},
		...(searchParams.get('employeeId') && employeeDetails?.OpeningBalance
			? [
					{
						key: 'openingBalance',
						label: <span>Opening Balance</span>,
						destroyInactiveTabPane: true,
						children: <OpeningBalance />,
					},
			  ]
			: []),
	].filter(Boolean);

	if (searchParams.get('employeeId')) {
		if (!permissions.includes('Edit_Employment')) {
			items = items.filter((item) => item.key !== 'employmentDetails');
		}
		if (!permissions.includes('Edit_Taxation')) {
			items = items.filter((item) => item.key !== 'taxationDetails');
		}
		if (!permissions.includes('Edit_Salary')) {
			items = items.filter((item) => item.key !== 'salaryDetails');
		}

		if (!permissions.includes('Edit_Payment_Info')) {
			items = items.filter((item) => item.key !== 'paymentInfo');
		}
		if (!permissions.includes('Edit_Documents')) {
			items = items.filter((item) => item.key !== 'documents');
		}
		if (!permissions.includes('Edit_Earnings')) {
			items = items.filter((item) => item.key !== 'earnings');
		}
		if (!permissions.includes('Edit_Deductions')) {
			items = items.filter((item) => item.key !== 'deductions');
		}
		if (!permissions.includes('Edit_Opening_Balance')) {
			items = items.filter((item) => item.key !== 'openingBalance');
		}
	} else {
		if (!permissions.includes('Add_Employment')) {
			items = items.filter((item) => item.key !== 'employmentDetails');
		}
		if (!permissions.includes('Add_Taxation')) {
			items = items.filter((item) => item.key !== 'taxationDetails');
		}
		if (!permissions.includes('Add_Salary')) {
			items = items.filter((item) => item.key !== 'salaryDetails');
		}

		if (!permissions.includes('Add_Payment_Info')) {
			items = items.filter((item) => item.key !== 'paymentInfo');
		}
		if (!permissions.includes('Add_Documents')) {
			items = items.filter((item) => item.key !== 'documents');
		}
		if (!permissions.includes('Add_Earnings')) {
			items = items.filter((item) => item.key !== 'earnings');
		}
		if (!permissions.includes('Add_Deductions')) {
			items = items.filter((item) => item.key !== 'deductions');
		}
		if (!permissions.includes('Add_Opening_Balance')) {
			items = items.filter((item) => item.key !== 'openingBalance');
		}
	}
	useEffect(() => {
		const employeeIdFromSearchParams = searchParams.get('employeeId');
		if (employeeIdFromSearchParams) {
			getEmployeeDetail(employeeIdFromSearchParams);
		} else {
			setEmployeeId('To be auto generated');
		}
		dispatch(fetchConstantDropdownAction({}));
	}, []);

	const getEmployeeDetail = async (employeeId: string) => {
		try {
			const employeeData = await employeeApi.getEmployeeDetailsById(
				employeeId
			);
			setEmployeeDetails(employeeData?.data?.data);
			setIsPayrollRun(employeeData?.data?.isPayrollInRun);
			setIsUsd(employeeData?.data?.data?.isUSD);

			setLastDateOfPayPeriod(employeeData?.data?.lastDateOfPayPeriod);

			setEmployeeId(employeeData?.data?.data?.employeeId);
			setIsEmployeeTaxationExists(
				employeeData?.data.data.TaxationDetails
			);
			setIsEmployeeSalaryExists(
	    employeeData?.data?.data?.isEmployeeSalaryExists
      );
		} catch (error: any) {
			let message =
				error?.response?.data?.message ||
				'Something went wrong in fetching employee details';
			navigate('/');
			toastText(message, 'error');
		}
	};

	const removeDrawerFromDom = () => {
		setIsEmployeeActivityOpen(false);
	};

	return (
		<Modal
			open={isAddEmployeeModalOpen}
			width={'100%'}
			onCancel={onCancel}
			className="preview-container"
			closable={false}
			style={{
				borderRadius: 0,
			}}
			footer={[]}
		>
			{isLoading ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '90vh',
					}}
				>
					<Spin
						size="large"
						style={{
							fontSize: '100px',
							color: '#584495',
						}}
					/>
				</div>
			) : (
				<div>
					<Row className={styles['preview-container__top']}>
						<div className={styles['preview-container__top-title']}>
							<b>{modalTitle}</b>
							<span className={styles['divider']}></span>

							<span
								className={
									styles[
										'preview-container__content--new-employee-header-first'
									]
								}
							>
								Employee ID: {employeeId}
							</span>
							{/* <b>Add Employee</b> */}
						</div>
						<Col
							span={4}
							className={
								styles[
									'preview-container__content--new-employee-header-second'
								]
							}
						>
							{searchParams.get('employeeId') && (
								<Button
									onClick={() =>
										setIsEmployeeActivityOpen(true)
									}
								>
									<HistoryOutlined />
								</Button>
							)}
							<div
								className={
									styles['preview-container__top-close']
								}
								onClick={() => {
									setEmployeeId('');
									onCancel();
								}}
							>
								<CloseSvg />
							</div>
						</Col>
					</Row>
					<div className={styles['preview-container__content']}>
						<div
							className={
								styles[
									'preview-container__content--new-employee-header-tabs'
								]
							}
						>
							<Tabs
								defaultActiveKey={activeKey}
								activeKey={activeKey}
								items={items}
								onChange={(key) => changeTab(key)}
								style={{
									fontSize: '18px',
									marginBottom: '40px',
								}}
							/>
						</div>
					</div>
				</div>
			)}

			{isEmployeeActivityOpen && (
				<SideDrawerWrapper
					isOpen={isEmployeeActivityOpen}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={removeDrawerFromDom}
					headerTitle={'Activity'}
					position="right"
					width="half"
				>
					<EmployeeActivityBody />
				</SideDrawerWrapper>
			)}
		</Modal>
	);
};

export default AddEmployee;
